export type UnsucessfulFetchErrorOptions = {
  readonly message?: string;
  readonly response: Response;
};

export class UnsucessfulFetchError extends Error {
  public readonly response: Response;

  public constructor({ message, response }: UnsucessfulFetchErrorOptions) {
    super(message ?? response.statusText);
    this.name = UnsucessfulFetchError.name;
    this.response = response;
  }

  public get url(): string {
    return this.response.url;
  }

  public get status(): number {
    return this.response.status;
  }
}

export function isUnsucessfulFetchError(
  value: unknown
): value is UnsucessfulFetchError {
  return (value as UnsucessfulFetchError).name === UnsucessfulFetchError.name;
}
